import React, { Fragment, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import withI18n from '../../../i18n';
import withGlobalConsumer from '../../../global/GlobalProvider';
import Button from 'reactstrap/es/Button';
import { FilterHorizontal } from './FilterHorizontal';
import Container from 'reactstrap/es/Container';
import { Modal, ModalBody, ModalHeader, NavLink } from 'reactstrap';
import Row from 'reactstrap/es/Row';
import Col from 'reactstrap/es/Col';
import apiClient from '../../../api/ApiClient';
import KotoTable from '../../common/KotoTable';
import { notificationService } from '../../notifications/NotificationService';
import { MdDelete } from 'react-icons/md';
import KotoModal from '../../common/KotoModal';
import KotoPrompt from '../../common/KotoPrompt';
import { FiMap } from 'react-icons/fi';

const SinglePool = ({ startLoading, stopLoading, translate, ...props }) => {
  const [promptDeleteOpen, setPromptDeleteOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [pool, setPool] = useState({});
  const [selectedLocations, setSelectedLocations] = useState([]);

  const handleSubmit = async () => {
    try {
      const response = await apiClient.patch(`/pools/${props.match.params.id}`, {
        locations: selectedLocations.map((sl) => sl.value)
      });
      notificationService.success('Uspešno posodobljene lokacije bazena');
      setModalOpen(false);
      await fetchPool();
    } catch (e) {
      //console.log(e);
      notificationService.error('Nekaj seje zalomilo');
    }
  };
  const fetchPool = async () => {
    try {
      const response = await apiClient.get(`/pools/${props.match.params.id}`);
      setPool(response.data);
      const locations = response.data.locations.map((location) => {
        return { value: location.id, label: location.name };
      });
      setSelectedLocations(locations);
    } catch (e) {
      notificationService.error('Nekaj seje zalomilo');
      //console.log(e);
    }
  };

  async function handleDelete() {
    try {
      await apiClient.delete(`/pools/${pool.id}`);
      notificationService.success('Bazen lokacij uspešno izbrisan!');
      setPromptDeleteOpen(false);
      props.history.push('/pools');
    } catch (e) {
      notificationService.error(e);
    }
  }

  const locationColumns = [
    {
      Header: 'Id',
      width: 200,
      accessor: 'id',
      Cell: (row) => (
        <NavLink className="pt-0 pb-0" to={`/locations/${row.original.id}`} tag={Link}>
          {row.original.id}
        </NavLink>
      )
    },
    {
      Header: 'Ime',
      width: 400,
      accessor: 'name'
    },
    {
      Header: 'Naslov',
      accessor: 'address'
    }
  ];

  useEffect(() => {
    fetchPool();
  }, []);

  return (
    <Fragment>
      <br />
      <Container fluid className={'px-3'}>
        <Row>
          <Col sm={8}>
            <h4>
              <i>Bazen lokacij: {pool?.name}</i>
            </h4>
          </Col>
          <Col sm={4} className="text-right align-self-center">
            <Button className="mr-2" color={'primary'} onClick={() => setModalOpen(true)}>
              <Row noGutters>
                <FiMap className={'mr-2'} style={{ cursor: 'pointer' }} size="1.5em"></FiMap>
                <div>Dodaj lokacije bazenu</div>
              </Row>
            </Button>
            <Button className="mr-2" color={'danger'} onClick={() => setPromptDeleteOpen(true)}>
              <Row noGutters>
                <MdDelete className="text-white mr-1" style={{ cursor: 'pointer' }} size="1.5em">
                  {' '}
                </MdDelete>
                <div>Izbriši</div>
              </Row>
            </Button>
          </Col>
        </Row>
        <br />
        <Modal style={{ maxWidth: '1900px', width: '80%' }} isOpen={modalOpen} toggle={() => setModalOpen(false)}>
          <ModalBody>
            <ModalHeader className="border-0 p-0 mt-3"></ModalHeader>
            <FilterHorizontal selectedLocations={selectedLocations} setSelectedLocations={setSelectedLocations} />
            <Row noGutters className="justify-content-end pt-3">
              <Button color={'primary'} onClick={async (e) => await handleSubmit()}>
                {translate('button_confirm')}
              </Button>

              <Button className={'ml-2'} color={'danger'} onClick={() => setModalOpen(false)}>
                {translate('button_cancel')}
              </Button>
            </Row>
          </ModalBody>
        </Modal>

        {pool?.locations && (
          <KotoTable
            data={pool.locations}
            defaultPageSize={20}
            minRows={20}
            showPagination={true}
            columns={locationColumns}
          />
        )}
      </Container>
      <KotoModal
        isOpen={promptDeleteOpen}
        toggle={() => setPromptDeleteOpen(!promptDeleteOpen)}
        title={'Izbriši bazen?'}
      >
        <KotoPrompt onConfirm={() => handleDelete()} onCancel={() => setPromptDeleteOpen(!promptDeleteOpen)} />
      </KotoModal>
    </Fragment>
  );
};

export default withRouter(withI18n(withGlobalConsumer(SinglePool)));
